<ion-header class="header --w-back-button">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-list class="breadcrumb">
        <ion-item
          *ngFor="let breadcrumb of breadcrumbs"
          class="breadcrumb__item"
          detail="false"
          routerDirection="back"
          [routerLink]="[breadcrumb.link]"
        >
          <span [innerHTML]="breadcrumb.name"></span> <span class="breadcrumb__item__dash">/</span>
        </ion-item>
      </ion-list>
      <ion-back-button [defaultHref]="routes.home" text="" icon="arrow-back-outline"></ion-back-button>
    </ion-buttons>
    <ion-title class="--logo">
      <a class="header__logo" [routerLink]="['/']">
        <app-logo></app-logo>
      </a>
      <span>Veranstaltungen verwalten</span>
    </ion-title>
    <ion-buttons slot="end">
      <ion-avatar class="header__avatar" [routerLink]="['..', routes.settings]">
        <img class="header__avatar__image" src="/assets/avatar/anna.svg" [alt]="(user$ | async)?.firstName" />
      </ion-avatar>
      <ion-menu-button class="header__burger" icon="menu-outline" autoHide="false"></ion-menu-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="events">
  <div class="white-wrapper">
    <div class="events__header">
      <ion-item class="events__header__search" [formGroup]="form">
        <ion-input formControlName="search" placeholder="Suche"></ion-input>
      </ion-item>
      <ion-icon
        *ngIf="(user$ | async)?.role === 'SUPER_ADMIN'"
        class="events__ellipsis"
        slot="icon-only"
        name="ellipsis-vertical"
        (click)="presentPopover($event)"
      ></ion-icon>
    </div>
    <ion-list class="events__list">
      <ion-item
        *ngFor="let content of eventContents$ | async | filterContents:form.value.search; trackBy: trackBy"
        class="events__list__item"
        detail="false"
        [routerLink]="[content.id]"
      >
        <div class="events__list__item__wrapper">
          <ion-img [src]="content.imageUrl || 'assets/icon/apple-touch-icon.png'" alt="" class="events__list__item__avatar"></ion-img>
          <div class="events__list__item__detail">
            <span class="events__list__item__detail__name" [innerHTML]="content.title"></span>
            <span class="events__list__item__detail__module" [innerHTML]="content.learningModules | mapModules"></span>
          </div>
        </div>
      </ion-item>
    </ion-list>
  </div>
</ion-content>
